export default "cea67507759d6e2c48605ef3509a8dbd.svg";